function Upload(options) {
  this.opts = { ...Upload.default, ...options };
  return this.init();
}

Upload.default = { headers: {} };

Upload.prototype.init = function() {
  const { name, file, headers, withCredentials, formData = {} } = this.opts;
  const form = new FormData();
  form.append(name, file);
  Object.keys(formData).map(key => form.append(key, formData[key]));

  this.xhr = new XMLHttpRequest();
  this.xhr.open(this.opts.method, this.opts.url, true);
  this.xhr.onload = this.uploadComplete.bind(this);
  this.xhr.onerror = this.uploadFailed.bind(this);
  this.xhr.upload.onprogress = this.uploadProgress.bind(this);
  this.xhr.upload.onloadstart = this.startUpload.bind(this);
  if (withCredentials) {
    this.xhr.withCredentials = true;
  }

  Object.keys(headers).map(key => this.xhr.setRequestHeader(key, headers[key]));

  this.xhr.send(form);
  return this.xhr;
};

Upload.prototype.uploadComplete = function(event) {
  if (this.xhr.status < 200 || this.xhr.status >= 300) {
    const { onError, key } = this.opts;
    onError && onError(key, event);
    return;
  }
  const { onSuccess, key } = this.opts;
  onSuccess && onSuccess(key, event);
};

Upload.prototype.uploadFailed = function(event) {
  const { onError, key } = this.opts;
  onError && onError(key, event);
};

Upload.prototype.uploadProgress = function(event) {
  const { onProgress, key } = this.opts;
  onProgress && onProgress(key, event);
};

Upload.prototype.startUpload = function(event) {
  const { onStart, key } = this.opts;
  onStart && onStart(key, event);
};

export default options => new Upload(options);
